var _path, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVisa4(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "visa-4-logo-svgrepo-com",
    xmlns: "http://www.w3.org/2000/svg",
    width: 53.004,
    height: 53.004,
    viewBox: "0 0 53.004 53.004",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_3903",
    "data-name": "Path 3903",
    d: "M0,0H53V53H0Z",
    fill: "#fff",
    fillRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3904",
    "data-name": "Path 3904",
    d: "M54.279,41.062c0-2.471-1.284-3.7-3.775-3.7H6.609a3.49,3.49,0,0,0-2.763,1.012,3.6,3.6,0,0,0-1.012,2.685V66.123a3.624,3.624,0,0,0,1.012,2.685A3.748,3.748,0,0,0,6.609,69.82H50.5c2.491,0,3.775-1.245,3.775-3.7ZM50.5,37.949a2.762,2.762,0,0,1,3.113,3.113V66.123c0,2.082-1.051,3.113-3.113,3.113H6.609a3,3,0,0,1-3.191-3.113V41.062c0-2.062,1.031-3.113,3.191-3.113Z",
    transform: "translate(-2.055 -27.09)",
    fill: "#315881",
    fillRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3905",
    "data-name": "Path 3905",
    d: "M12.5,44.724a2.313,2.313,0,0,0-1.654.428,2.8,2.8,0,0,0-.37,1.673v5.428H57.719V46.825a1.85,1.85,0,0,0-2.1-2.1Z",
    transform: "translate(-7.596 -32.426)",
    fill: "#315881",
    fillRule: "evenodd"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3906",
    "data-name": "Path 3906",
    d: "M10.477,125.794c0,1.439.681,2.179,2.023,2.179H55.617a1.9,1.9,0,0,0,2.1-2.179v-5.429H10.477Z",
    transform: "translate(-7.596 -87.267)",
    fill: "#dfa43b",
    fillRule: "evenodd"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3907",
    "data-name": "Path 3907",
    d: "M43.1,77.3a1,1,0,0,1-.136.584L39.56,83.814l-.214-7.238H33.9l1.829.876a1.493,1.493,0,0,1,.8,1.3l.506,7.686H39.7l6.382-9.865H42.81A.968.968,0,0,1,43.1,77.3Zm22.026-.428.214-.292H62.014c.117.117.156.175.156.214a3.737,3.737,0,0,1-.156.37l-4.845,8.833c-.117.156-.234.292-.37.448h2.743l-.136-.292a4.183,4.183,0,0,1,.428-1.381l.584-1.09h2.821c.117.915.195,1.674.234,2.238l-.234.525h3.405l-.506-.739ZM63.1,82.3H61.08l1.732-3.327ZM54.7,76.07a4.487,4.487,0,0,0-2.743.876,2.211,2.211,0,0,0-1.3,1.946,3.123,3.123,0,0,0,.934,2.315l1.888,1.3c.681.487,1.012.915,1.012,1.3a1.185,1.185,0,0,1-.506.953,1.823,1.823,0,0,1-1.168.37,9.093,9.093,0,0,1-3.463-1.381v1.809a7.164,7.164,0,0,0,3.677,1.148,4.258,4.258,0,0,0,2.9-1.012,2.553,2.553,0,0,0,.291-4.261l-1.81-1.3c-.6-.486-.934-.915-.934-1.245,0-.759.447-1.148,1.362-1.148a6.118,6.118,0,0,1,2.763,1.09l.37-1.887A6.483,6.483,0,0,0,54.7,76.07ZM47.46,86.441c-.039-.409-.117-.778-.156-1.168L49.775,77.3l.584-.72H46.8c.039.175.078.409.117.584a3.033,3.033,0,0,1-.039.584l-2.471,7.9-.506.8H47.46Z",
    transform: "translate(-24.577 -55.152)",
    fill: "#315881",
    fillRule: "evenodd"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisa4);
export default __webpack_public_path__ + "static/media/visa-4.a41735e3b704588ccfa727e6a9a4de7d.svg";
export { ForwardRef as ReactComponent };